// src/services/feedback.js
import { functions } from './firebase';
import { httpsCallable } from 'firebase/functions';

/**
 * Submit feedback (bug report or suggestion) to the backend
 * @param {Object} feedbackData - The feedback data to submit
 * @param {string} feedbackData.type - 'bug' or 'suggestion'
 * @param {string} feedbackData.title - Title/summary of the feedback
 * @param {string} feedbackData.description - Detailed description
 * @param {string} feedbackData.userId - User ID submitting the feedback
 * @param {string} feedbackData.companyName - Company name
 * @param {string} feedbackData.email - User email
 * @param {boolean} [feedbackData.quickFeedback] - Whether this is from the quick banner
 * @param {string} [feedbackData.stepsToReproduce] - For bugs: steps to reproduce
 * @param {string} [feedbackData.expectedBehavior] - For bugs: expected behavior
 * @param {string} [feedbackData.actualBehavior] - For bugs: actual behavior
 * @param {string} [feedbackData.pageFeature] - For bugs: page/feature where bug occurred
 * @param {string} [feedbackData.browser] - For bugs: browser/device info
 * @param {string} [feedbackData.category] - For suggestions: category
 * @param {string} [feedbackData.priority] - For suggestions: priority level
 * @returns {Promise<Object>} - Result from the Cloud Function
 */
export const submitFeedback = async (feedbackData) => {
  try {
    const submitFeedbackFunction = httpsCallable(functions, 'submitFeedback');
    const result = await submitFeedbackFunction(feedbackData);
    return result.data;
  } catch (error) {
    console.error('Error submitting feedback:', error);
    
    // Provide more helpful error messages
    if (error.code === 'unauthenticated') {
      throw new Error('You must be logged in to submit feedback');
    } else if (error.code === 'invalid-argument') {
      throw new Error('Please fill in all required fields');
    } else {
      throw new Error(error.message || 'Failed to submit feedback. Please try again.');
    }
  }
};